import React, { useContext, useEffect, useState, useMemo } from "react";
import { Layout, Menu, Typography, Drawer, Button, Modal, Card, Badge, message, Input, Statistic } from "antd";
import {
  HomeOutlined,
  FileAddOutlined,
  FileTextOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  CalendarOutlined,
  CalendarFilled,
  ClockCircleOutlined,
  CheckCircleOutlined,
  SolutionOutlined,
  FileDoneOutlined,
  AuditOutlined,
  RiseOutlined,
  AlertOutlined,
  LogoutOutlined,
  HistoryOutlined,
  FormOutlined,
  MenuOutlined,
  EditOutlined,
  MoreOutlined,
  HourglassOutlined,
  WalletOutlined
} from "@ant-design/icons";
import { AuthContext } from "../../context/AuthContext";
import { useNavigation } from "../../context/NavigationContext";
import DashboardHeader from "../../components/dashboardheader/DashboardHeader";
import Footer from "../../components/footer/Footer";
import CreateMrf from "../createmrf/CreateMrf";
import HodViewReq from "../hod_viewreq/HodViewReq";
import InterviewPage from "../interviewpage/InterviewPage";
import ViewTeam from "../hod/ViewTeam";
import ViewAnnouncement from "../../components/employee/ViewAnnouncement";
import Teamleaves from "../../components/Teamleaves";
import TeamCompoff from "../../components/employee/TeamCompoff";
import TeamPermissions from "../../components/TeamPermissions";
import OffDay from "../../components/employee/OffDay";
import Permission from "../../components/employee/Permission";
import Leaves from "../../components/employee/Leaves";
import Holidays from "../employee/Holidays";
import TeamAttendance from "../../components/TeamAttendance";
import ViewEmpAttendance from "../../components/attendance/viewEmpAttendance";
import Rfc from "../../components/Rfc";
import ProbationReview from "../../components/employee/ProbationReview";
import WeddingGreetings from "../../components/WeddingGreetings";
import OtApprovals from "../../components/OtApprovals";
import TeamAssessment from "../TeamAssessment";
import PipApprovals from "../PipApprovals";
import ResignationRequests from "../ResignationRequests";
import LeaveCalendar from "../../components/employee/LeaveCalendar";
import ViewBirthDay from "../../components/ViewBirthDay";
import WorkCard from "../../components/WorkCard";
import axios from "axios";
import Welcome from "../../components/Welcome";
import OverallEmployees from "../../components/employee/OverallEmployees"
import InduvidualAttendance from "../employee/InduvidualAttendance";
import EmployeeProfile from "../EmployeeProfile";
import NotificationBar from "../NotificationBar";
import SignatureUpdation from "../payroll/SignatureUpdation";
import OrgChart from "../OrgChart";
import UserImg from "../../assests/user_avatar.png";
import PastOnduty from "../employee/PastOnduty";
import Resignation from "../Resignation";
import ListNoc from "../ListNoc";
import ExitInterview from "../ExitInterview";
import TeamMembers from "../hod/TeamMembers";
import OnDutyAttendance from "../../components/OndutyAttendance";
import AppliedOnduty from "../employee/AppliedOnDuty"
import PaySlip from "../../components/PaySlip";

const { Sider, Content } = Layout;
const { Title } = Typography;
const { TextArea } = Input

export default function Hoddashboard() {
  const { authData, backUrl } = useContext(AuthContext);
  const { registerNavigator } = useNavigation();

  const [selectedMenu, setSelectedMenu] = useState(
    localStorage.getItem("hodDashboardPage") || "home"
  );

  // Register this dashboard's menu setter so NotificationBar can navigate into it
  useEffect(() => {
    const cleanup = registerNavigator((menuKey) => setSelectedMenu(menuKey));
    return cleanup;
  }, [registerNavigator]);
  const [showProfile, setShowProfile] = useState(false)
  const [isHovered, setIsHovered] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // ────── NEW STATE FOR HOME PAGE (copied from EmployeeDashboard) ──────
  const [showWishes, setShowWishes] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);
  const [celebrations, setCelebrations] = useState({ birthdays: [], work_anniversaries: [] });
  const [eventsModalVisible, setEventsModalVisible] = useState(false);
  const [mywishes, setMyWishes] = useState([]);
  const [wishModalVisible, setWishModalVisible] = useState(false);
  const [wishMessage, setWishMessage] = useState("");
  const [selectedPerson, setSelectedPerson] = useState(null);

  useEffect(() => {
    localStorage.setItem("hodDashboardPage", selectedMenu);
  }, [selectedMenu]);

  useEffect(() => {
    const welcomeShown = localStorage.getItem("welcomeShown");
    if (welcomeShown) {
      setShowWelcome(true);
      setTimeout(() => {
        localStorage.setItem("welcomeShown", "false");
        setShowWelcome(false);
      }, 3000);
    }
  }, []);

  // Responsive handling
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ────── FETCH CELEBRATIONS & MY WISHES (same as EmployeeDashboard) ──────
  const fetchWishes = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/probation/celebrations/today/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setCelebrations(res.data);
    } catch (error) {
      console.error("Error fetching celebrations:", error);
    }
  };

  const fetchMyWishes = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/probation/celebrations/my/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setMyWishes(res.data);
    } catch (error) {
      console.error("Error fetching my wishes:", error);
    }
  };

  useEffect(() => {
    fetchWishes();
    fetchMyWishes();
  }, [authData, backUrl]);
  // ─────────────────────────────────────────────────────────────────────

  const handleOpenWishModal = (person) => {
    setSelectedPerson(person);
    setWishModalVisible(true);
  };

  const [leaveDetails, setLeaveDetails] = useState(null);

  const getLeaveSummary = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/hr/leave-summary/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setLeaveDetails(res.data);
    }
    catch (error) {
      console.error("Error fetching leaves:", error);

    }
  }

  useEffect(() => {
    getLeaveSummary();
  }, []);

  const handleSendWish = async () => {
    try {
      const payload = {
        receiver_id: selectedPerson?.id ?? 0,
        occasion: "BIRTHDAY",
        message: wishMessage,
      };
      await axios.post(`${backUrl}/api/probation/celebrations/send/`, payload, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      message.success(`Wish sent successfully!`);
      setWishModalVisible(false);
      setWishMessage("");
      fetchMyWishes(); // refresh my wishes
    } catch (error) {
      console.error("Error sending wish:", error);
      message.error("Failed to send wish. Try again later.");
    }
  };

  const LeaveSummary = ({ data }) => {
    const { allotments, balances, totals } = data;

    const statBox = (bg) => ({
      background: bg,
      padding: "16px",
      borderRadius: "10px",
      textAlign: "center",
      flex: "1",
      width: "100px"
    });

    const flexContainer = {
      display: "flex",
      flexWrap: "wrap",
      gap: "16px",
      width: "100%"
    };

    return (
      <div style={{ width: "100%", padding: 10 }}>

        {/* Allotments */}
        <Card title="Leave Allotments" style={{ marginBottom: 20 }}>
          <div style={flexContainer}>

            <div style={statBox("#ffdceacc")}>
              <Statistic
                title="Sick"
                value={allotments.SL}
                prefix="🤒"
              />
            </div>

            <div style={statBox("#ffcbffc1")}>
              <Statistic
                title="Casual"
                value={allotments.CL}
                prefix="🏖️"
              />
            </div>

            <div style={statBox("#ffffd9de")}>
              <Statistic
                title="Comp/Week Off"
                value={(allotments.Compoff ?? 0) + (allotments.WeekOff ?? 0)}
                prefix="🛌"
              />
            </div>

          </div>
        </Card>

        {/* Totals */}
        <Card title="Leaves Taken" style={{ marginBottom: 20 }}>
          <div style={flexContainer}>

            <div style={statBox("#ffdceacc")}>
              <Statistic
                title="SL Taken"
                value={totals.SL_Taken}
                prefix="🤒"
              />
            </div>

            <div style={statBox("#ffcbffc1")}>
              <Statistic
                title="CL Taken"
                value={totals.CL_Taken}
                prefix="🏖️"
              />
            </div>

            <div style={statBox("#d4f4ffc9")}>
              <Statistic
                title="Comp Off"
                value={totals.Compoff_Taken}
                prefix="🛌"
              />
            </div>

            <div style={statBox("#ffffd9de")}>
              <Statistic
                title="Week Off"
                value={totals.WeekOff_Taken}
                prefix="🛌"
              />
            </div>

          </div>
        </Card>

        {/* Balances */}
        <Card title="Leave Balances" style={{ marginBottom: 20 }}>
          <div style={flexContainer}>

            <div style={statBox("#ffdceacc")}>
              <Statistic
                title="Sick"
                value={balances.SL}
                prefix="🤒"
              />
            </div>

            <div style={statBox("#ffcbffc1")}>
              <Statistic
                title="Casual"
                value={balances.CL}
                prefix="🏖️"
              />
            </div>

            <div style={statBox("#d4f4ffc9")}>
              <Statistic
                title="Comp Off"
                value={balances.Compoff}
                prefix="🛌"
              />
            </div>

            <div style={statBox("#ffffd9de")}>
              <Statistic
                title="Week Off"
                value={balances.WeekOff}
                prefix="🛌"
              />
            </div>

          </div>
        </Card>

      </div>
    );
  };

  // Menu items (memoized)
  const menuItems = useMemo(
    () => [
      { key: "home", icon: <HomeOutlined />, label: "Dashboard" },
      // { key: "viewprofile", icon: <CheckCircleOutlined />, label: "View Profile" },
      // ---------------- MRF ----------------
      {
        key: "mrf",
        icon: <FormOutlined />,
        label: "MRF",
        children: [
          { key: "applyMRF", icon: <FileAddOutlined />, label: "Apply MRF" },
          { key: "viewRequisitions", icon: <FileTextOutlined />, label: "View Requisitions" },
          { key: "teamRequisitions", icon: <TeamOutlined />, label: "Team Requisitions" },
        ],
      },
      {
        key: "teamLeaves",
        icon: <TeamOutlined />,
        label: "Team Details",
        children: [
          { key: "teamMembers", icon: <FileDoneOutlined />, label: "Team Members" },
          { key: "leaveRequests", icon: <FileDoneOutlined />, label: "Leave Requests" },
          { key: "compoffRequests", icon: <HistoryOutlined />, label: "Team off day workings" },
          { key: "permissionRequests", icon: <ClockCircleOutlined />, label: "Permission Requests" },
          { key: "onduty", icon: <ClockCircleOutlined />, label: "Onduty Requests" },
          { key: "teamattendance", icon: <TeamOutlined />, label: "Team Attendance" },
          { key: "rfc", icon: <AlertOutlined />, label: "Request for Consideration" },
          { key: "teamemployement", icon: <SolutionOutlined />, label: "Probation" },
          { key: "overall", icon: <CheckCircleOutlined />, label: "Confirmed" },

          // 0  { key: "otapproval", icon: <CheckCircleOutlined />, label: "Over Time Requests"},

          { key: "otapproval", icon: <CheckCircleOutlined />, label: "Over Time Requests" },
          {
            key: "pipapprovals",
            icon: <SolutionOutlined />,
            label: "PIP Approvals",
          },
          {
            key: "showselfassessments",
            icon: <RiseOutlined />,
            label: "Team Assessments",
          },
        ],
      },
      { key: "payslip", icon: <WalletOutlined />, label: "Payslip" },
      // {
      //   key: "teamLeaves",
      //   icon: <CalendarOutlined />,
      //   label: "Team Permission & Leave",
      //   children: [
      //     { key: "leaveRequests", icon: <FileDoneOutlined />, label: "Leave Requests" },
      //     { key: "compoffRequests", icon: <HistoryOutlined />, label: "Weekoff Requests" },
      //     { key: "permissionRequests", icon: <ClockCircleOutlined />, label: "Permission Requests" },
      //   ],
      // },
      // ---------------- Attendance ----------------
      {
        key: "attendance",
        icon: <ClockCircleOutlined />,
        label: "Attendance",
        children: [
          { key: "myattendance", icon: <ClockCircleOutlined />, label: "View Attendance" },
          { key: "applyOnduty", icon: <HourglassOutlined />, label: "Apply On Duty" },
          {
            key: "appliedOnDuty",
            icon: <HourglassOutlined />,
            label: "Applied On Duty",
          },
        ],
      },
      // ---------------- Employment Status ----------------
      // {
      //   key: "teamemp",
      //   icon: <UserSwitchOutlined />,
      //   label: "Team Employment Status",
      //   children: [
      //     { key: "teamemployement", icon: <SolutionOutlined />, label: "Probation" },
      //     { key: "overall", icon: <CheckCircleOutlined />, label: "Confirmed" },
      //     { key: "pips", icon: <CheckCircleOutlined />, label: "Raised PIP Requests" },
      //   ],
      // },
      // ---------------- Leave Management ----------------
      {
        key: "leaveManagement",
        icon: <CalendarFilled />,
        label: "Leave Management",
        children: [
          // { key: "offDayDutyApply", icon: <FileAddOutlined />, label: "Off Day Working Apply" },
          { key: "holidays", icon: <CalendarOutlined />, label: "Holidays" },
          { key: "permissions", icon: <ClockCircleOutlined />, label: "Permissions" },
          { key: "leaves", icon: <FileDoneOutlined />, label: "Leaves" },
        ],
      },
      // ---------------- Interview ----------------
      {
        key: "interview",
        icon: <AuditOutlined />,
        label: "Interview & Assessment",
      },

      // {
      //   key: "signatureUpdation",
      //   icon: <EditOutlined />,
      //   label: "Signature Updation",
      // },
      // {
      //   key: "orgchart",
      //   icon: <TeamOutlined />,
      //   label: "ORG Chart",
      // },
      // ---------------- OT ----------------
      // {
      //   key: "otapproval",
      //   icon: <CheckCircleOutlined />,
      //   label: "Over Time Requests",
      // },
      // ---------------- Team Assessments ----------------
      // {
      //   key: "showselfassessments",
      //   icon: <RiseOutlined />,
      //   label: "Team Assessments",
      // },
      // ---------------- PIP Approvals ----------------
      // {
      //   key: "pipapprovals",
      //   icon: <SolutionOutlined />,
      //   label: "PIP Approvals",
      // },
      // ---------------- HR Resignation Requests ----------------
      // {
      //   key: "resignationRequests",
      //   icon: <FileTextOutlined />,
      //   label: "Resignation Requests",
      // },
      {
        key: "resignation",
        icon: <MoreOutlined />,
        label: "Others",
        children: [
          { key: "resignation", icon: <LogoutOutlined />, label: "Apply Resignation" },
          {
            key: "resignationRequests",
            icon: <FileTextOutlined />,
            label: "Resignation Requests",
          },
          authData?.assigned_dept_head_id && {
            key: "NocClearence",
            icon: <FileDoneOutlined />,
            label: "NOC Clearance",
          },
          authData?.is_exit_interview_triggered && {
            key: "exitInterview",
            icon: <FormOutlined />,
            label: "Exit Interview",
          },
        ],
      },
    ],
    []
  );

  const handleBack = () => {
    setShowProfile(false)
  }


  // Render selected page content
  const renderContent = () => {
    switch (selectedMenu) {
      case "home":
        return showWelcome ? (
          <Welcome />
        ) :
          showProfile ? (
            <EmployeeProfile onBack={handleBack} />
          ) :
            (<>
              {
                showProfile ? (
                  <EmployeeProfile onBack={handleBack} />
                ) : (
                  <div
                    style={{
                      background: "#ffffffff",
                      minHeight: "100vh",
                      padding: isMobile ? "16px" : "24px",
                    }}
                  >
                    {authData?.your_under_pip && (
                      <div
                        className="d-flex align-items-center gap-3 mb-4"
                        style={{
                          background: "#fff3cd",
                          border: "1px solid #ffeeba",
                          padding: "16px",
                          borderRadius: "8px",
                        }}
                      >
                        <span style={{ fontSize: "22px" }}>⚠️</span>
                        <Typography.Title
                          level={4}
                          style={{
                            margin: 0,
                            color: "#856404",
                            fontWeight: "600",
                            fontSize: isMobile ? "14px" : "16px",
                          }}
                        >
                          You are currently under PIP — {authData?.pip_days_remaining} days remaining for review
                        </Typography.Title>
                      </div>
                    )}

                    <div className="container-fluid px-0" style={{ maxWidth: "1500px", margin: "0 auto" }}>
                      <div className="row g-4">
                        {/* LEFT SECTION */}
                        <div className="col-12 col-lg-6">
                          <div className="mb-4">
                            <Badge
                              count={
                                celebrations.birthdays.length +
                                celebrations.work_anniversaries.length
                              }
                              color="#ff4d4f"
                            >
                              <Typography.Title
                                level={5}
                                className="w-100"
                                style={{
                                  margin: 0,
                                  color: "#0E497B",
                                  fontWeight: 600,
                                  fontSize: 14,
                                  cursor: "pointer",
                                  border: "1px solid #0E497B",
                                  padding: "8px 16px",
                                  borderRadius: 20,
                                  textAlign: "center",
                                  display: "block",
                                }}
                                onClick={() => setEventsModalVisible(true)}
                              >
                                🎉 Events Today
                              </Typography.Title>
                            </Badge>
                          </div>

                          <div style={{ height: isMobile ? "350px" : "400px" }}>
                            <LeaveCalendar style={{ height: "100%" }} />
                          </div>
                          {
                            isMobile && (
                              <>
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                              </>
                            )
                          }
                        </div>

                        {/* RIGHT SECTION */}
                        <div className="col-12 col-lg-6" style={{ marginTop: isMobile ? "5" : "25px" }}>
                          <Card
                            onClick={() => setShowProfile(true)}
                            className="mb-3"
                            style={{
                              width: "100%",
                              marginTop: isMobile ? "0" : "-40px",
                              background: "linear-gradient(135deg, #0E497B, #1A6FB3)",
                              color: "white",
                              borderRadius: "12px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                              height: "60px",
                              cursor: "pointer",
                              transform: isHovered ? "scale(1.05)" : "scale(1)",
                              transition: "transform 0.25s ease",
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                          >
                            <div
                              className="d-flex flex-row justify-content-around align-items-center w-100"
                            >
                              <img
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  border: "3px solid rgba(255,255,255,0.7)",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                  marginTop: "-20px",
                                  transition: "transform 0.25s ease",
                                }}
                                src={
                                  authData?.employee?.photo
                                    ? `${authData?.employee?.photo}`
                                    : UserImg
                                }
                                alt="Your Image"
                              />

                              <p
                                style={{
                                  color: "white",
                                  fontWeight: 600,
                                  fontSize: "15px",
                                  marginLeft: "20px",
                                  marginTop: "-5px",
                                  userSelect: "none",
                                  marginBottom: 0,
                                }}
                              >
                                View Profile
                              </p>
                            </div>
                          </Card>

                          <div className="text-center mt-2 mb-3">
                            {(authData?.is_birthday_today ||
                              authData?.is_wedding_today ||
                              authData?.is_work_anniversary_today) && (
                                <Button
                                  type="primary"
                                  onClick={() => setShowWishes((prev) => !prev)}
                                  style={{
                                    backgroundColor: "#0E497B",
                                    borderColor: "#0E497B",
                                    borderRadius: "10px",
                                    fontWeight: 600,
                                    padding: "10px 18px",
                                  }}
                                >
                                  {showWishes ? "Hide Wishes" : "💌 View My Wishes"}
                                </Button>
                              )}
                          </div>

                          {showWishes && (
                            <Card
                              bordered={false}
                              className="mb-4"
                              style={{
                                borderRadius: "14px",
                                padding: isMobile ? "16px" : "24px",
                                boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                background: "#FFFFFF",
                              }}
                            >
                              <Typography.Title
                                level={4}
                                style={{
                                  color: "#0E497B",
                                  textAlign: "center",
                                  marginBottom: "24px",
                                  fontSize: isMobile ? "18px" : "24px",
                                }}
                              >
                                💌 My Wishes
                              </Typography.Title>

                              {mywishes?.length > 0 ? (
                                <div className="row g-3">
                                  {mywishes.map((wish) => (
                                    <div key={wish.id} className="col-12 col-sm-12 col-xl-12">
                                      <Card
                                        hoverable
                                        style={{
                                          borderRadius: "12px",
                                          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                          padding: "5px",
                                        }}
                                      >
                                        <div className="d-flex mb-3">
                                          {wish.sender_photo ? (
                                            <img
                                              src={wish.sender_photo}
                                              alt={wish.sender_name}
                                              onError={(e) => { e.target.style.display = "none"; }}
                                              style={{
                                                width: "52px",
                                                height: "52px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                marginRight: "14px",
                                                flexShrink: 0,
                                              }}
                                            />
                                          ) : (
                                            <div
                                              style={{
                                                width: "52px",
                                                height: "52px",
                                                borderRadius: "50%",
                                                marginRight: "14px",
                                                flexShrink: 0,
                                                background: "#ccc",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#fff",
                                                fontWeight: 600,
                                              }}
                                            >
                                              {wish.sender_name?.charAt(0).toUpperCase()}
                                            </div>
                                          )}
                                          <div>
                                            <Typography.Text strong style={{ fontSize: 15 }}>
                                              {wish.sender_name}
                                            </Typography.Text>
                                            <br/>
                                            <Typography.Text style={{ fontSize: 15 }}>
                                              {wish.sender_department}
                                            </Typography.Text>
                                            <br/>
                                            <Typography.Text style={{ fontSize: 15 }}>
                                              {wish.sender_designation}
                                            </Typography.Text>
                                            <br />
                                            <Typography.Text
                                              type="secondary"
                                              style={{ fontSize: "13px" }}
                                            >
                                              {wish.occasion === "BIRTHDAY"
                                                ? "🎂 Birthday"
                                                : wish.occasion === "WORK_ANNIVERSARY"
                                                  ? "🏆 Work Anniversary"
                                                  : wish.occasion}
                                            </Typography.Text>
                                          </div>
                                        </div>

                                        <Typography.Paragraph
                                          style={{
                                            background: "#F5F8FA",
                                            borderRadius: "10px",
                                            padding: "14px",
                                            fontStyle: "italic",
                                            minHeight: "70px",
                                            fontSize: 14,
                                            marginBottom: "8px",
                                          }}
                                        >
                                          "{wish.message}"
                                        </Typography.Paragraph>

                                        <Typography.Text
                                          type="secondary"
                                          style={{
                                            fontSize: "12px",
                                            display: "block",
                                            textAlign: "right",
                                          }}
                                        >
                                          {new Date(wish.created_at).toLocaleDateString(
                                            "en-GB"
                                          )}
                                        </Typography.Text>
                                      </Card>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <p style={{ textAlign: "center", color: "#888" }}>
                                  You haven't received any wishes yet ✨
                                </p>
                              )}
                            </Card>
                          )}

                          {/* ANNOUNCEMENTS */}
                          <div style={{
                            width: "100%",
                          }} >
                            <ViewAnnouncement />
                          </div>

                          <div style={{
                            width: "100%",
                          }}>
                            {leaveDetails && <LeaveSummary data={leaveDetails} />}
                          </div>


                        </div>
                      </div>
                    </div>

                    {/* MODALS */}
                    {/* EVENTS MODAL */}
                    <Modal
                      title="Events Today"
                      open={eventsModalVisible}
                      onCancel={() => setEventsModalVisible(false)}
                      footer={null}
                      width={isMobile ? "95%" : 900}
                      style={{ top: isMobile ? 20 : undefined }}
                    >
                      {celebrations.birthdays.length === 0 &&
                        celebrations.work_anniversaries.length === 0 ? (
                        <p>No events today 🎈</p>
                      ) : (
                        <>
                          {celebrations.birthdays.length > 0 && (
                            <Card
                              title="🎂 Birthdays"
                              size="small"
                              className="mb-3"
                            >
                              {celebrations.birthdays.map((emp) => (
                                <div key={emp.id}>
                                  <ViewBirthDay employee={emp} />
                                  <br />
                                </div>
                              ))}
                            </Card>
                          )}

                          {celebrations.work_anniversaries.length > 0 && (
                            <Card title="🏆 Work Anniversaries" size="small">
                              {celebrations.work_anniversaries.map((emp) => (
                                <WorkCard key={emp.id} employee={emp} />
                              ))}
                            </Card>
                          )}
                        </>
                      )}
                    </Modal>

                    {/* SEND WISH MODAL */}
                    <Modal
                      title={`Send Wish to ${selectedPerson
                        ? `${selectedPerson.user.first_name} ${selectedPerson.user.last_name}`
                        : ""
                        }`}
                      open={wishModalVisible}
                      onCancel={() => setWishModalVisible(false)}
                      onOk={handleSendWish}
                      okText="Send Wish"
                      width={isMobile ? "95%" : 520}
                      style={{ top: isMobile ? 20 : undefined }}
                    >
                      <TextArea
                        rows={4}
                        placeholder="Write your message..."
                        value={wishMessage}
                        onChange={(e) => setWishMessage(e.target.value)}
                        style={{
                          borderRadius: "8px",
                        }}
                      />
                    </Modal>
                  </div>
                )
              }
            </>)
      case "applyMRF":
        return <CreateMrf onSubmitSuccess={() => setSelectedMenu("viewRequisitions")} />;
      case "viewRequisitions":
        return <HodViewReq />;
      case "teamRequisitions":
        return <ViewTeam />;
      case "leaveRequests":
        return <Teamleaves />;
      case "compoffRequests":
        return <TeamCompoff />;
      case "permissionRequests":
        return <TeamPermissions />;
      case "holidays":
        return <Holidays />;
      case "offDayDutyApply":
        return <OffDay />;
      case "permissions":
        return <Permission />;
      case "leaves":
        return <Leaves />;
      case "interview":
        return <InterviewPage />;
      case "teamattendance":
        return <TeamAttendance />;
      case "myattendance":
        return <ViewEmpAttendance />;
      case "rfc":
        return <Rfc />;
      case "teamemployement":
        return <ProbationReview />;
      case "otapproval":
        return <OtApprovals is_employee_view={true} />;
      case "showselfassessments":
        return <TeamAssessment />;
      case "pipapprovals":
        return <PipApprovals />;
      case "resignationRequests":
        return <ResignationRequests />;
      case "overall":
        return <OverallEmployees />;
      case "signatureUpdation":
        return <SignatureUpdation />
      case "orgchart":
        return <OrgChart />
      case "onduty":
        return <PastOnduty />
      case "resignation":
        return <Resignation />
      case "NocClearence":
        return <ListNoc />
      case "exitInterview":
        return <ExitInterview />
      case "teamMembers":
        return <TeamMembers />
      case "applyOnduty":
        return <OnDutyAttendance />
      case "appliedOnDuty":
        return <AppliedOnduty />
      case "payslip":
        return <PaySlip />;
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <DashboardHeader />
      {/* <img  src={Bemss} alt="logo" /> */}

      {/* Mobile top bar */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}
      <Layout style={{ background: "#fff" }}>
        {/* Desktop Sidebar */}
        {!isMobile && (
          <Sider
            width={280}
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}
            theme="light"
            style={{
              background: "#fff",
              borderRight: "1px solid #f0f0f0",
              boxShadow: "2px 0 6px rgba(0,0,0,0.05)",
            }}
          >
            <style>
              {`
                .ant-menu {
                  background: #fff !important;
                  border-right: none !important;
                }
                .ant-menu-item, .ant-menu-submenu-title {
                  font-weight: bold;
                  color: #0e497b !important;
                  transition: all 0.2s ease;
                }
                .ant-menu-item:hover,
                .ant-menu-submenu-title:hover {
                  background-color: rgba(14, 73, 123, 0.05) !important;
                  color: #0e497b !important;
                }
                .ant-menu-item-selected {
                  background-color: #0e497b !important;
                  color: #fff !important;
                }
                .ant-menu-item-selected .anticon {
                  color: #fff !important;
                }
                .ant-menu-submenu-arrow::before,
                .ant-menu-submenu-arrow::after {
                  background-color: #0e497b !important;
                }
              `}
            </style>
            <br />


            <Menu
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={({ key }) => setSelectedMenu(key)}
              style={{ height: "100%", borderRight: 0, background: "#fff", fontWeight: "bold" }}
              items={menuItems}
            />
          </Sider>
        )}
        {/* Mobile Drawer Sidebar */}

        <Drawer
          title="Navigation"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >

          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            onClick={({ key }) => {
              setSelectedMenu(key);
              setDrawerVisible(false);
            }}
            style={{ height: "100%", borderRight: 0, background: "#fff", fontWeight: "bold" }}
            items={menuItems}
          />
        </Drawer>
        {/* Main Content */}
        <Layout style={{ padding: isMobile ? "10px" : "24px", background: "#fff" }}>
          <Content style={{ background: "#fff" }}>{renderContent()}</Content>
        </Layout>
      </Layout>
      <Footer style={{ background: "#fff" }} />
    </Layout>
  );
}